import * as types from '../constants/invite';
import { mapErrorMessage } from '../../Utils/mapErrorMessage';
import { toast } from 'react-toastify';
import parseDjangoError from '../../Utils/parseDjangoError';

const INITIAL_STATE = {
  isLoading: false,
  success: false,
  error: null,
  data: null,
  invitedData: null,
  isValidInvitations: null,
  projectPendingInvitations: [],
  orgPendingInvitations: [],
};
let toastId = null;
export default function inviteApiReducer(state = INITIAL_STATE, action) {
  const newState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    // invite
    case types.API_INVITE_REQUEST:
      toastId = toast.loading('Please wait...');
      return {
        ...state,
        isLoading: true,
        success: false,
      };

    case types.API_INVITE_REQUEST_SUCCESS:
      toast.update(toastId, {
        render: 'Invitation sent!',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
        closeButton: true,
      });
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        data: action.response.data,
      };

    case types.API_INVITE_REQUEST_FAILED:
      toast.update(toastId, {
        render: parseDjangoError(action.response.response.data),
        type: 'error',
        isLoading: false,
        autoClose: 3000,
        closeButton: true,
      });
      return {
        ...state,
        isLoading: false,
        success: false,
        error: mapErrorMessage(action),
      };

    case types.API_CHECK_INVITATION_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
      };

    case types.API_CHECK_INVITATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: null,
        isValidInvitations: true,
        invitedData: action.response.data,
      };

    case types.API_CHECK_INVITATION_FAILED:
      toast.error(parseDjangoError(action.response.response.data));
      return {
        ...state,
        isLoading: false,
        success: false,
        isValidInvitations: false,
        error: mapErrorMessage(action),
      };

    case types.API_GET_PENDING_INVITATIONS_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
      };

    case types.API_GET_PROJECT_PENDING_INVITATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        projectPendingInvitations: action.response.data.result
      };

    case types.API_GET_ORG_PENDING_INVITATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        orgPendingInvitations: action.response.data.result
      };

    case types.API_GET_PENDING_INVITATIONS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.API_RESEND_INVITATION_REQUEST:
      toastId = toast.loading('Please wait...');
      return {
        ...state,
        isLoading: true,
        success: false,
      };

    case types.API_RESEND_INVITATION_SUCCESS:
      toast.update(toastId, {
        render: 'Invitation resent!',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
        closeButton: true,
      });
      return {
        ...state,
        isLoading: false,
        success: true,
        error: null,
        data: action.response.data,
      };

    case types.API_INVITE_REQUEST_FAILED:
      toast.update(toastId, {
        render: 'Failed to resend invitation.',
        type: 'error',
        isLoading: false,
        autoClose: 3000,
        closeButton: true,
      });
      return {
        ...state,
        isLoading: false,
        success: false,
        error: action.response.response.data.error,
      };

    case types.RESET_INVITE:
      return {
        ...state,
        isLoading: false,
        success: false,
        error: null,
        isValidInvitations: null,
        invitedData: null,
      };

    default:
      return state;
  }
}
